import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariant = cva(
  cn(
    "vf-inline-flex vf-items-center vf-justify-center vf-gap-2 vf-whitespace-nowrap vf-rounded vf-text-sm vf-font-medium vf-ring-offset-white",
    "focus-visible:vf-outline-none focus-visible:vf-ring-2 focus-visible:vf-ring-primary-500 focus-visible:vf-ring-offset-2",
    "disabled:vf-pointer-events-none disabled:vf-opacity-50 vf-t vf-px-1.5",
    "[&_svg]:vf-pointer-events-none [&_svg]:vf-size-4 [&_svg]:vf-shrink-0"
  ),
  {
    variants: {
      variant: {
        primary: "vf-bg-primary-500 vf-text-neutral-50",
        danger: "vf-bg-danger-500 vf-text-neutral-50",
        success: "vf-bg-success-500 vf-text-neutral-50",
        info: "vf-bg-info-500 vf-text-neutral-50",
        warning: "vf-bg-warning-500 vf-text-neutral-50",
        muted: "vf-bg-neutral-200 vf-text-neutral-600",

        "outline-primary":
          "vf-border vf-border-primary-500 vf-text-primary-500 vf-bg-primary-50",
        "outline-danger":
          "vf-border vf-border-danger-500 vf-text-danger-500 vf-bg-danger-50",
        "outline-success":
          "vf-border vf-border-success-500 vf-text-success-500 vf-bg-success-50",
        "outline-info":
          "vf-border vf-border-info-500 vf-text-info-500 vf-bg-info-50",
        "outline-warning":
          "vf-border vf-border-warning-500 vf-text-warning-500 vf-bg-warning-50",
        "outline-muted":
          "vf-border vf-border-neutral-600 vf-text-neutral-600 vf-bg-neutral-200",

        ghost: "vf-bg-transparent vf-text-inherit",
      },
    },
    defaultVariants: {
      variant: "muted",
    },
  }
);

export default badgeVariant;
